export default __webpack_public_path__ + "static/media/notebook.1e712a52.png";